var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Person"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2359 13.1909C4.10452 12.3464 5.27897 11.875 6.5 11.875H13.5C14.721 11.875 15.8955 12.3464 16.7641 13.1909C17.6333 14.036 18.125 15.186 18.125 16.3889V18.3333C18.125 18.6785 17.8452 18.9583 17.5 18.9583C17.1548 18.9583 16.875 18.6785 16.875 18.3333V16.3889C16.875 15.529 16.5238 14.7007 15.8928 14.0872C15.2611 13.473 14.4007 13.125 13.5 13.125H6.5C5.5993 13.125 4.73892 13.473 4.10725 14.0872C3.47617 14.7007 3.125 15.529 3.125 16.3889V18.3333C3.125 18.6785 2.84518 18.9583 2.5 18.9583C2.15482 18.9583 1.875 18.6785 1.875 18.3333V16.3889C1.875 15.186 2.36668 14.036 3.2359 13.1909Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99998 2.29175C8.04397 2.29175 6.45831 3.87741 6.45831 5.83341C6.45831 7.78942 8.04397 9.37508 9.99998 9.37508C11.956 9.37508 13.5416 7.78942 13.5416 5.83341C13.5416 3.87741 11.956 2.29175 9.99998 2.29175ZM5.20831 5.83341C5.20831 3.18705 7.35362 1.04175 9.99998 1.04175C12.6463 1.04175 14.7916 3.18705 14.7916 5.83341C14.7916 8.47978 12.6463 10.6251 9.99998 10.6251C7.35362 10.6251 5.20831 8.47978 5.20831 5.83341Z",
    fill: "#818181"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/Person.64688db96b488148d8dc2bf733e49fc8.svg";
export { ForwardRef as ReactComponent };